var map = {
	"./ai-icon-blue.svg": 78060,
	"./ai-icon.svg": 38487,
	"./arrow.svg": 56412,
	"./checkbox-hover.svg": 20747,
	"./checkbox.svg": 61338,
	"./clear-hover.svg": 93925,
	"./clear.svg": 30320,
	"./close-ai-recommend.svg": 30747,
	"./delete.svg": 4412,
	"./diagramanalysis.svg": 46250,
	"./flowchart.svg": 16799,
	"./img-lazy-error.svg": 54196,
	"./img-lazy-loading-dark.svg": 87619,
	"./img-lazy-loading.svg": 20114,
	"./left-search-banner.svg": 62378,
	"./mindmap.svg": 56437,
	"./more-template.svg": 67177,
	"./new-file.svg": 5616,
	"./refresh.svg": 33694,
	"./right-arrow.svg": 83021,
	"./search-no.svg": 42511,
	"./search.svg": 35389,
	"./set.svg": 65311,
	"./templates.svg": 49926,
	"./vip.svg": 58238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71345;